module.exports = __webpack_public_path__ + "static/media/Himalaya-01.0184110b.svg";